// Syft ACP - Core <https://github.com/Syft-Application/syft2acp>
// © Syft Online Limited

import * as types from './action-types'

export function uploadImage(uuid, file) {
  return { type: types.UPLOAD_IMAGE_BEGIN, uuid, file }
}
